var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled, { css } from 'styled-components';
import { getFontSize, getFontWeight } from '../../abstracts/typography';
import { colors } from '../../abstracts/colors';
import { iconOnlyFigmaStyle, iconOnlyStyle, btnSizeIconMargins, focusStyles, } from '../Button/elements';
var smallButtonCss = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 1.75rem;\n  padding: 0 1rem;\n"], ["\n  height: 1.75rem;\n  padding: 0 1rem;\n"])));
var largeButtonCss = css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  height: 3.75rem;\n  padding: 0 1.75rem;\n  font-size: ", ";\n"], ["\n  height: 3.75rem;\n  padding: 0 1.75rem;\n  font-size: ", ";\n"])), getFontSize(3));
var getButtonSizeCss = function (size) {
    if (size === 'small')
        return smallButtonCss;
    if (size === 'large')
        return largeButtonCss;
    return undefined;
};
var getTypeDefaultCss = function (color) { return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  &:not(.disabled) {\n    ", "\n    &:hover {\n      background: ", ";\n      border-color: ", ";\n    }\n    &:active {\n      background: ", ";\n      border-color: ", ";\n      color: ", ";\n    }\n  }\n  &.disabled {\n    background: ", ";\n    border-color: ", ";\n  }\n  background: ", ";\n  border-color: ", ";\n  color: ", ";\n"], ["\n  &:not(.disabled) {\n    ", "\n    &:hover {\n      background: ", ";\n      border-color: ", ";\n    }\n    &:active {\n      background: ", ";\n      border-color: ", ";\n      color: ", ";\n    }\n  }\n  &.disabled {\n    background: ", ";\n    border-color: ", ";\n  }\n  background: ", ";\n  border-color: ", ";\n  color: ", ";\n"])), focusStyles, function (_a) {
    var theme = _a.theme;
    return theme["".concat(color, "Hover")];
}, function (_a) {
    var theme = _a.theme;
    return theme["".concat(color, "Hover")];
}, function (_a) {
    var theme = _a.theme;
    return theme["".concat(color, "Pressed")];
}, function (_a) {
    var theme = _a.theme;
    return theme["".concat(color, "Pressed")];
}, function (_a) {
    var theme = _a.theme;
    return color === 'primary' ? theme.textOnPrimary : theme.textOnSecondary;
}, colors.disabledBackground, colors.disabledBackground, function (_a) {
    var theme = _a.theme;
    return theme[color];
}, function (_a) {
    var theme = _a.theme;
    return theme[color];
}, function (_a) {
    var theme = _a.theme;
    return color === 'primary' ? theme.textOnPrimary : theme.textOnSecondary;
}); };
var getTypeOutlineCss = function (color) { return css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  &:not(.disabled) {\n    ", "\n    &:hover {\n      background: ", ";\n    }\n    &:active {\n      background: ", ";\n      border-color: ", ";\n      color: ", ";\n    }\n  }\n  &.disabled {\n    border-color: ", ";\n  }\n  background: transparent;\n  color: ", ";\n  border: 2px solid;\n  border-color: ", ";\n"], ["\n  &:not(.disabled) {\n    ", "\n    &:hover {\n      background: ", ";\n    }\n    &:active {\n      background: ", ";\n      border-color: ", ";\n      color: ", ";\n    }\n  }\n  &.disabled {\n    border-color: ", ";\n  }\n  background: transparent;\n  color: ", ";\n  border: 2px solid;\n  border-color: ", ";\n"])), focusStyles, colors.neutralBrightest, colors.neutralBrighter, function (_a) {
    var theme = _a.theme;
    return theme["".concat(color, "Pressed")];
}, function (_a) {
    var theme = _a.theme;
    return theme["".concat(color, "Pressed")];
}, colors.disabledText, function (_a) {
    var theme = _a.theme;
    return theme[color];
}, function (_a) {
    var theme = _a.theme;
    return theme[color];
}); };
var getTypeFlatCss = function (color) { return css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  &:not(.disabled) {\n    ", "\n    &:hover {\n      background: ", ";\n      border-color: ", ";\n      text-decoration: unset;\n    }\n    &:active {\n      background: ", ";\n      border-color: ", ";\n      color: ", ";\n    }\n  }\n  color: ", ";\n  background: transparent;\n  border-color: transparent;\n"], ["\n  &:not(.disabled) {\n    ", "\n    &:hover {\n      background: ", ";\n      border-color: ", ";\n      text-decoration: unset;\n    }\n    &:active {\n      background: ", ";\n      border-color: ", ";\n      color: ", ";\n    }\n  }\n  color: ", ";\n  background: transparent;\n  border-color: transparent;\n"])), focusStyles, colors.neutralBrightest, colors.neutralBrightest, colors.neutralBrighter, colors.neutralBrighter, function (_a) {
    var theme = _a.theme;
    return theme["".concat(color, "Pressed")];
}, function (_a) {
    var theme = _a.theme;
    return theme[color];
}); };
var getTypeTextCss = function (color) { return css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  &:not(.disabled) {\n    ", "\n    &:hover {\n      color: ", ";\n    }\n    &:active {\n      color: ", ";\n    }\n  }\n\n  margin: 0;\n  padding: 0;\n  border: none;\n  border-radius: 1px;\n  color: ", ";\n  text-decoration: underline;\n  text-underline-position: under;\n  background: inherit;\n  height: initial;\n"], ["\n  &:not(.disabled) {\n    ", "\n    &:hover {\n      color: ", ";\n    }\n    &:active {\n      color: ", ";\n    }\n  }\n\n  margin: 0;\n  padding: 0;\n  border: none;\n  border-radius: 1px;\n  color: ", ";\n  text-decoration: underline;\n  text-underline-position: under;\n  background: inherit;\n  height: initial;\n"])), focusStyles, function (_a) {
    var theme = _a.theme;
    return theme["".concat(color, "Hover")];
}, function (_a) {
    var theme = _a.theme;
    return theme["".concat(color, "Pressed")];
}, function (_a) {
    var theme = _a.theme;
    return theme[color];
}); };
export var getButtonVariantCss = function (variant, color) {
    switch (variant) {
        case 'default':
            return getTypeDefaultCss(color);
        case 'outline':
            return getTypeOutlineCss(color);
        case 'flat':
            return getTypeFlatCss(color);
        case 'text':
            return getTypeTextCss(color);
        default:
            return getTypeDefaultCss(color);
    }
};
var buttonPadding = function (_a) {
    var $iconPresent = _a.$iconPresent, $iconSide = _a.$iconSide, $btnSize = _a.$btnSize;
    if (!$iconPresent)
        return '';
    if ($btnSize !== 'small') {
        return $iconSide === 'left'
            ? 'padding-left: 1.25rem'
            : 'padding-right: 1.25rem';
    }
    else {
        return $iconSide === 'left'
            ? 'padding-left: 0.75rem'
            : 'padding-right: 0.75rem';
    }
};
export var AnchorButtonVariant = styled.a(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  text-decoration: none;\n  border-radius: 10rem;\n  font-family: inherit;\n  font-weight: ", ";\n  font-style: normal;\n  font-size: ", ";\n  height: 2.75rem;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-style: solid;\n  border-width: 2px;\n\n  letter-spacing: 0;\n  width: auto;\n  text-align: center;\n  white-space: nowrap;\n  padding: 0 1.75rem;\n\n  &:hover:not(.disabled) {\n    cursor: pointer;\n  }\n  ", ";\n  ", ";\n\n  ", ";\n  ", "\n\n  ", ";\n\n  &.disabled {\n    color: ", ";\n    -webkit-text-fill-color: ", ";\n    cursor: not-allowed;\n    &:active,\n    &:focus,\n    &:focus-within,\n    &:focus-visible {\n      pointer-events: none;\n    }\n  }\n"], ["\n  text-decoration: none;\n  border-radius: 10rem;\n  font-family: inherit;\n  font-weight: ", ";\n  font-style: normal;\n  font-size: ", ";\n  height: 2.75rem;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-style: solid;\n  border-width: 2px;\n\n  letter-spacing: 0;\n  width: auto;\n  text-align: center;\n  white-space: nowrap;\n  padding: 0 1.75rem;\n\n  &:hover:not(.disabled) {\n    cursor: pointer;\n  }\n  ", ";\n  ", ";\n\n  ", ";\n  ", "\n\n  ", ";\n\n  &.disabled {\n    color: ", ";\n    -webkit-text-fill-color: ", ";\n    cursor: not-allowed;\n    &:active,\n    &:focus,\n    &:focus-within,\n    &:focus-visible {\n      pointer-events: none;\n    }\n  }\n"])), getFontWeight('base'), getFontSize(2), function (_a) {
    var $btnSize = _a.$btnSize;
    return getButtonSizeCss($btnSize);
}, function (_a) {
    var $btnVariant = _a.$btnVariant, $btnColor = _a.$btnColor;
    return getButtonVariantCss($btnVariant, $btnColor);
}, function (_a) {
    var $iconPresent = _a.$iconPresent, $iconSide = _a.$iconSide, $btnSize = _a.$btnSize;
    return buttonPadding({ $iconPresent: $iconPresent, $iconSide: $iconSide, $btnSize: $btnSize });
}, function (_a) {
    var $childrenPresent = _a.$childrenPresent, $btnSize = _a.$btnSize, $useFigmaStyles = _a.$useFigmaStyles;
    if (!$childrenPresent) {
        return $useFigmaStyles
            ? iconOnlyFigmaStyle[$btnSize]
            : iconOnlyStyle[$btnSize];
    }
}, function (_a) {
    var $iconPresent = _a.$iconPresent, $btnVariant = _a.$btnVariant;
    return !$iconPresent && $btnVariant === 'flat'
        ? 'text-decoration: underline; text-underline-position: under;'
        : '';
}, colors.disabledText, colors.disabledText);
export var BtnVariantIconWrapper = styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  margin: ", ";\n"], ["\n  margin: ", ";\n"])), function (_a) {
    var $childrenPresent = _a.$childrenPresent, $iconSide = _a.$iconSide, $size = _a.$size;
    return $childrenPresent
        ? $iconSide === 'left'
            ? btnSizeIconMargins[$size].left
            : btnSizeIconMargins[$size].right
        : '0';
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;
